import React from 'react';
import { CardCollection } from '@hz-design-system/web-ui';

import FeedItem from './FeedItem';
import FeedItemListSkeleton from './FeedItemListSkeleton';

import { TFeedItem } from 'types/TFeeds';

type TFeedsItemsProps = {
  items: TFeedItem[];
  isLoading: boolean;
  shouldOpenInNewTab?: boolean;
};

const FeedItemList = ({ items, isLoading }: TFeedsItemsProps) => (
  <>
    {isLoading && <FeedItemListSkeleton />}
    {!isLoading && (
      <CardCollection kind="grid">
        {items.map((item, i) => (
          <FeedItem item={item} key={`${item.itemId}-${i}`} />
        ))}
      </CardCollection>
    )}
  </>
);

export default FeedItemList;
